const routingUrl = {
    landingPageUrls: {
      up: '',
      down: '/home/about-us'
    },
    aboutUsUrls: {
      up: '/',
      down: '/home/projects'
    },
    projectsUrls: {
        up: '/home/about-us',
        down: '/home/process'
    },
    processUrls: {
        up: '/home/projects',
        down: '/home/contact'
    },  
    contactUrls: {
        up: '/home/process',
        down: ''
    }  
}

  export default routingUrl